import React from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ChevronRight, Home } from "lucide-react";

export const PageHeader = ({ eyebrow, title, subtitle, breadcrumbs = [] }) => {
  return (
    <section
      className="relative pt-40 pb-20 md:pt-48 md:pb-28 bg-paper border-b border-stone-200"
      data-testid="page-header"
    >
      <div className="container-x relative">
        <motion.nav
          initial={{ opacity: 0, y: 6 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.4 }}
          className="flex items-center gap-1.5 text-[11px] tracking-[0.18em] uppercase text-brand-muted mb-7"
        >
          <Link to="/" className="hover:text-brand-navyDark flex items-center gap-1">
            <Home className="w-3 h-3" /> Home
          </Link>
          {breadcrumbs.map((b, i) => (
            <React.Fragment key={i}>
              <ChevronRight className="w-3 h-3" />
              <span className={i === breadcrumbs.length - 1 ? "text-brand-navyDark" : ""}>
                {b}
              </span>
            </React.Fragment>
          ))}
        </motion.nav>

        {eyebrow && (
          <motion.div
            initial={{ opacity: 0, y: 8 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            className="eyebrow mb-5"
          >
            {eyebrow}
          </motion.div>
        )}
        <motion.h1
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.05 }}
          className="heading-serif text-5xl sm:text-6xl md:text-[5rem] font-medium tracking-tight text-brand-navyDark leading-[1.04] max-w-4xl"
        >
          {title}
        </motion.h1>
        {subtitle && (
          <motion.p
            initial={{ opacity: 0, y: 12 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.12 }}
            className="mt-7 text-[17px] text-brand-body max-w-2xl leading-[1.8]"
          >
            {subtitle}
          </motion.p>
        )}
      </div>
    </section>
  );
};
